export default __webpack_public_path__ + "static/media/chevron.8f7ec5ee.svg";